export const usePlatform = () => {
  let platform: "web" | "mobile" = "web";

  if (/Android|iPhone/i.test(window.navigator.userAgent)) {
    platform = "mobile";
  }

  return platform;
};
